import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';


@Component({
  selector: 'app-stylists',
  templateUrl: './stylists.page.html',
  styleUrls: ['./stylists.page.scss'],
})
export class StylistsPage implements OnInit {
@Input()data:any
item;
// showCalender=false;
  time: any;
  constructor( private modalController: ModalController,
    ) { }

  ngOnInit() {
  }
  ionViewWillEnter(){
    console.log('stylist modal',this.data)
  }
  close(){
    this.modalController.dismiss({stylist:this.item,date:this.time})
  }
  choose(s){
    console.log(s);
    this.item=s;
    // this.showCalender=true;
    this.close()
  }
  
  // date(e){
  //   console.log(e)
  //   this.time=e.detail.value;
  // }
  // switch(){
  //   this.showCalender=false;
  // }
}
